import { Injectable } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { VistaCustomField, VistaCustomFieldDefinition } from '../../../type-definitions/general/general';
import { UdFieldsBySMCoType, SMGetServiceItemForms_Result } from '../../../type-definitions/field-service/responses/field-service';

@Injectable({
  providedIn: 'root',
})
export class SmDataService {
  private _handler: Subject<string> = new Subject<string>();

  boradcast(text: string) {
    this._handler.next(text);
  }

  subscribe(callback: (text: any) => void): Subscription {
    return this._handler.subscribe(callback);
  }

  public indexedDBVersion = 31;
  public allDBTable = [
    'SM_GetWorkOrderTripsIsHistory',
    'SM_GetWorkOrderTripsNotHistory',
    'SM_GetServiceItemWOHistory',
    'SM_GetWorkOrderScopesIsHistory',
    'SM_GetWorkOrderScopesNotHistory',
    'SM_GetWorkCompleted',
    'SM_GetTechnicians',
    'SM_GetServiceItemDetails',
    'SM_GetCommonLookups',
    'SM_GetEquipRevCode',
    'SM_GetSettingsBySMCo',
    'SM_GetScopeTasks',
    'SM_GetScopePurchaseOrders',
    'SM_GetFormsPerScope',
    'SM_GetFormTemplateOptions',
    'SM_GetSignerContacts',
    'SM_GetCustomers',
    'SM_GetServiceCenters',
    'SM_GetSitesByCustomer',
    'SM_GetServiceItemParts',
    'SM_GetMaterial',
    'SM_GetStandardItems',
    'SM_GetEquipment',
    'SM_GetMaterialWLoc',
    'SM_GetSettingsTable',
    'SM_OfflineSyncTrip',
    'SM_WCCustomFieldDefs',
    'SM_GetCommonWoLookups',
  ];

  public enablePWA: boolean;
  public lastScroll: any;
  public isDrillDown = false;
  public clockInStatus: any;
  public where: any;
  public attachmentWhere: any;
  public maxDollarAmount: any;
  public scopePageScroll: any;
  public isCloseOut: any;
  public isClockOut: any;
  public previousSM: any;
  public position: any;
  public toRebind: any;
  public clockInOutEnable: any;
  public bypassAttach: any;
  public loadAttachData: any;
  public closeOutTotalList: any;
  public signCount: any;
  public signList: any;
  public tempClose: any;
  public signatures: any;
  public tempOldTripNotes: any;
  public tempOldScopeNotes: any;
  public showCompleted: any;
  public modalMsg: any;
  public initLoading = false;
  public navbarHeight = 0;
  public readyToCompleteList = [];

  public SMDisableGenSign: any;
  public SMLaborCodeDefault: any;
  public SMTripDefaultFromBuffer: any;
  public SMTripDefaultToBuffer: any;
  public SMAllowManualPO: any;
  public Timecard24Hours: any;
  public SMHideSummary: any;
  public SMShowSiteNotesOnDash: any;
  public FSShowEquipmentEntryLabor: any;
  public FSShowBreakHours: any;
  public SMHideServiceItem: any;
  public SMPaymentURL: any;
  public AllowNegAmount: any;
  public requireAttachments: any;
  public AllowZeroHourTimeLine: any;
  public SMIncludeUnscheduled: any;
  public SMShowBudgetHour: any;
  public SMInvLocDisable: any;
  public SMPORouteToField: any;
  public SMCallTypeRequire: any;
  public SMShowBudgetedHoursOnScope: boolean;

  //Manage
  public allShow = false;
  public saveResult: any;
  public isReadyToCompleteSelected = false;
  //Details
  public taskShowComplete: any;
  public scopeNoData: any;
  public completedList: any;
  public customFieldDefinitions: VistaCustomFieldDefinition[];
  public customFieldsBySMCoType: UdFieldsBySMCoType[];
  public updatedSIList = [];
  public woUsedSIList = [];
  //Editing
  public editingMode: any;
  public addOrEdit: any;
  public editingData: any;
  public isNewItem: any;
  //Service Details
  public serviceDetailsFromDetails: any;
  public serviceDetailsFromGrid: any;
  public serviceDetailsFromQRCode: any;
  public serviceDetailsData: any;
  public currentTripList: any;
  //POQuickCreate
  public pOCreate: any;
  public POSaved: any;
  //FormInstance
  public templateData: any;
  public formHistoryList: SMGetServiceItemForms_Result[];
  public formHistory = false;
  //CloseOut
  public totalTripCharge: any;
  public totalTaxCharge: any;
  public isCollectSignature: any;
  public collectPayment: any;
  public closeDetailsList: any;
  public tempCloseExcludeForInvoice: any;
  public revisitReason: any;
  public revisitNotes: any;
  public revisitRequired: any;
  //ServiceItem
  public currentServiceItem: any;
  public qrCodeNoData = false;
  //Nav
  public haveOfflinePostFail: any;
  //--------------------------
  public haveOfflinePost: boolean;
  public offlinePostCallList: any;
  public offlinePostFailList: any;

  public isFromSMWODashNow: boolean;
  public isFromSMWODashNowWithTrip: boolean;
  public SMWODashToManID: any;
  public SMWODashToManIDWithTrip: any;
  public fromDatePicker: any;
  public toDatePicker: any;
  public clockStatus: any;
  public clockEmpty: boolean;

  public currentWorkOrder: any;
  public currentOnline: any;
  public currentScope: any;
  public currentWorkOrderScopeData: any;
  public currentScopeSettings: any;
  public currentEditSuperList: any;
  public currentTemplate: any;

  public technicianListRawLabor: any;
  public technicianListRaw: any;
  public tripList = [];
  public tripListFiltered = [];
  public signDisList = {};
  public signOffList = [];
  public signOffListRaw = [];
  public emailCCList = [];
  public lookupList = {};
  public addItemList = [];
  constructor() {}

  public ShellCustomFieldsBySMCoType(smco: number, typeStr: string): VistaCustomField[] {
    let customFieldsToReturn: VistaCustomField[] = [];

    if (
      this.customFieldDefinitions === null ||
      this.customFieldDefinitions === undefined ||
      this.customFieldDefinitions.length === 0 ||
      this.customFieldsBySMCoType === null ||
      this.customFieldsBySMCoType === undefined ||
      this.customFieldsBySMCoType.length === 0
    ) {
      return customFieldsToReturn;
    }

    let type = 0;
    switch (typeStr) {
      case 'Equipment':
        type = 1;
        break;
      case 'Labor':
        type = 2;
        break;
      case 'Misc':
        type = 3;
        break;
      case 'Inventory':
        type = 4;
        break;
      case 'PO':
        type = 5;
        break;
    }

    const validUdFields = this.customFieldsBySMCoType.find(item => item.SMCo === smco && item.Type === type);
    if (
      validUdFields === null ||
      validUdFields === undefined ||
      validUdFields.UdFields === null ||
      validUdFields.UdFields === undefined ||
      validUdFields.UdFields.length === 0
    ) {
      return customFieldsToReturn;
    }

    const customFieldDefsForType: VistaCustomFieldDefinition[] = this.customFieldDefinitions.filter(
      def => def.Form == this.typeToFormInternal(typeStr) && validUdFields.UdFields.includes(def.ColumnName)
    );

    customFieldsToReturn = customFieldDefsForType.map((definition: VistaCustomFieldDefinition) => {
      return {
        Seq: definition.Seq,
        ColumnValue: definition.Type === 'checkbox' ? 'N' : null,
        KeyID: null,
        Invalid: false,
      };
    });
    return customFieldsToReturn;
  }

  private typeToFormInternal(type: string): string {
    let form = '';
    switch (type) {
      case 'Equipment':
        form = 'SMWorkCompletedEquipment';
        break;
      case 'Labor':
        form = 'SMWorkCompletedLabor';
        break;
      case 'Misc':
        form = 'SMWorkCompletedMisc';
        break;
      case 'Inventory':
        form = 'SMWorkCompletedInventory';
        break;
      case 'PO':
        form = 'SMWorkCompletedPurchase';
        break;
    }
    return form;
  }

  public typeToForm(): string {
    return this.typeToFormInternal(this.editingMode);
  }
}
